import { useCallback } from 'react';
import useWeb3 from '../useWeb3';
import { getOracle } from '../../utils/contractHelpers';
import { useRecoilValue } from 'recoil';
import { userSmartAccount } from '../../components/RecoilAtom';

export const useDisputeEndTime = () => {
    const web3 = useWeb3();
    const smartAccount = useRecoilValue(userSmartAccount)

    const disputeEndTime = useCallback(async (address) => {
        const contract = getOracle(address, web3)
        try {
            const disputeTimer = await contract.methods.getExternalSource().call();
            const getDisputeTimerFromExternal = disputeTimer[6]
            return getDisputeTimerFromExternal;
        } catch (e) {
            console.error("Transaction error:", e.message || e);
            throw e;
        }
    }, [smartAccount, web3]);
    return disputeEndTime;
};

export default useDisputeEndTime;